import type { CatalogItem, CatalogCategory } from './catalog';

export interface CatalogSection {
  id: string;
  name: string;
  children: Array<{ id: string; name: string }>;
}

export type CatalogCategorySelection = 'all' | 'uncategorized' | string;

export function buildCatalogSections(items: CatalogItem[]): CatalogSection[] {
  const roots = new Map<string, CatalogSection>();
  let hasUncategorized = false;

  for (const item of items) {
    const category = item.category ?? null;
    if (!category) {
      hasUncategorized = true;
      continue;
    }
    const rootId = category.parentId ?? category.id;
    const rootName = category.parentName ?? category.name;
    const section = roots.get(rootId) ?? { id: rootId, name: rootName, children: [] };
    if (category.parentId && !section.children.some((child) => child.id === category.id)) {
      section.children.push({ id: category.id, name: category.name });
      section.children.sort((a, b) => a.name.localeCompare(b.name, 'es'));
    }
    roots.set(rootId, section);
  }

  const sections = [...roots.values()].sort((a, b) => a.name.localeCompare(b.name, 'es'));
  if (hasUncategorized) sections.push({ id: 'uncategorized', name: 'Sin categoría', children: [] });
  return sections;
}

export function filterCatalogByCategory(
  items: CatalogItem[],
  selectedId: CatalogCategorySelection,
): CatalogItem[] {
  if (selectedId === 'all') return items;
  if (selectedId === 'uncategorized') return items.filter((item) => !item.category);
  return items.filter((item) => matchesCategory(item.category ?? null, selectedId));
}

function matchesCategory(category: CatalogCategory | null, selectedId: string): boolean {
  return category?.id === selectedId || category?.parentId === selectedId;
}
